// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__18KCd","pageSize":"Paginate_pageSize__VO9t7"};